"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'grid',
        gridTemplateColumns: 'repeat(8, 1fr)',
        gridGap: 10,
        gridAutoRows: 'minmax(25px, auto)',
        fontSize: 14,
        padding: '8px 0',
        borderTop: `1px solid ${theme.grey6}`,
        color: theme.grey2
    },
    borderBottom: {
        display: 'grid',
        gridTemplateColumns: 'repeat(8, 1fr)',
        gridGap: 10,
        gridAutoRows: 'minmax(25px, auto)',
        fontSize: 14,
        padding: '8px 0',
        borderTop: `1px solid ${theme.grey6}`,
        borderBottom: `1px solid ${theme.grey6}`,
        color: theme.grey2
    },
    main: {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gridColumn: '1/5'
    },
    cell1: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gridColumn: '8/8'
    },
    cell2: {
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gridColumn: '7/8'
    },
    cell3: {
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gridColumn: '5/7'
    }
});
//# sourceMappingURL=directory.row.style.js.map